<template>
  <spinner size="huge" style="position: absolute; margin: 100px 45%" />
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  components: {
    Spinner
  },
}
</script>
